export default {
  data() {
    return {
      //row 1
      dashboardAdmissionTime: '',
      dashboardAdmissionTimeInterval: null,
      dashboardAdmissionResponseTimeAverage: null,
      dashboardAdmissionMissionCount: null,
      dashboardAdmissionCallsCount: null,
      //row 2
      //line call chart
      dashboardAdmissionLineCallChartOptions: {
        chart: {
          type: 'spline',
          height: '240px',
          zoomType: 'x',
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        xAxis: {
          categories: [],
          type: 'datetime',
        },
        legend: {
          enabled: true,
          useHTML: true,
        },
        yAxis: {
          title: {
            text: '',
          },
          labels: {
            format: '{value}',
          },
        },
        tooltip: {
          useHTML: true,
          crosshairs: true,
          shared: true,
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: '#666666',
              lineWidth: 1,
            },
          },
        },
        series: [],
      },
      //pie rank
      dashboardAdmissionPieRankChartOptions: {
        colors: [],
        chart: {
          renderTo: 'dashboardAdmissionPieRankChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 90,
            depth: 50,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'اولویت ها',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      //row 3
      dashboardAdmissionColumnHospitalChartOptions: {
        chart: {
          type: 'column',
          height: '240px',
        },
        title: {
          text: '',
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        exporting: {
          chartOptions: {
            xAxis: [
              {
                labels: {
                  rtl: true,
                  style: {
                    fontSize: '7px',
                    color: '#000000',
                    direction: 'ltr',
                    textAlign: 'right',
                    width: '170px',
                    wordWrap: 'break-word',
                  },
                  rotation: -45,
                },
                tickLength: 0,
              },
            ],
          },
        },
        xAxis: {
          type: 'category',
          useHTML: true,
          reversed: true,
          labels: {
            style: {
              fontSize: '9px',
              color: '#000000',
              textAlign: 'right',
              width: '120px',
              wordWrap: 'break-word',
            },
            useHTML: true,
          },
          tickLength: 0,
        },
        yAxis: {
          title: {
            text: '',
          },
          opposite: false,
          useHTML: true,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            color: '#2EBA7F',
            useHTML: true,
            dataLabels: {
              enabled: false,
              format: '{point.text}',
              x: 2,
              style: {
                fontWeight: 'normal',
                color: '#000000',
                fontSize: '12px',
              },
              useHTML: true,
            },
          },
          column: {
            depth: 25,
          },
        },
        tooltip: {
          useHTML: true,
          headerFormat: '<span class="tooltipHeader" style="color:#ffffff;"></span>',
          pointFormat:
            '<div class="tooltipPointWrapper">‎' +
            '<span style="color:#ffffff">{point.name}</span>: <span  style="color:#ffffff">{point.text}</span></div>',
        },
        series: [
          {
            name: 'تشخیص',
            keys: ['name', 'y', 'text'],
            data: [],
          },
        ],
      },
    };
  },
  methods: {
    readyAdmissionDashboard: function (data) {
      //row 1
      let duration = Math.round(data.workingHours.valueDouble);
      duration = duration * 1000;
      this.dashboardAdmissionTimeInterval = setInterval(() => {
        duration = duration + 1000;
        this.dashboardAdmissionTime = this.msToTime(duration);
      }, 1000);
      this.dashboardAdmissionMissionCount = data.missionsCount.valueLong;
      this.dashboardAdmissionCallsCount = data.callsCount.valueLong;
      let duration2 = Math.round(data.responseTimeAverage.valueDouble);
      duration2 = duration2 * 1000;
      this.dashboardAdmissionResponseTimeAverage = this.msToTime(duration2);
      //rows 2
      // line chart
      if (data.callsByDate.length > 0) {
        let info = [];
        for (let j = 0; j < data.callsByDate[0].subItems.length; j++) {
          let text = data.callsByDate[0].subItems[j].title.split(' ');
          this.dashboardAdmissionLineCallChartOptions.xAxis.categories.push(text[1]);
        }
        for (let i = 0; i < data.callsByDate.length; i++) {
          info.push({ name: data.callsByDate[i].title, data: [] });
          for (let j = 0; j < data.callsByDate[i].subItems.length; j++) {
            info[i].data.push(data.callsByDate[i].subItems[j].valueLong);
          }
        }
        this.dashboardAdmissionLineCallChartOptions.series = info;
      }
      //pie rank chart
      let pieChartData = JSON.parse(JSON.stringify([]));
      let pieChartTempArray = JSON.parse(JSON.stringify([]));
      pieChartTempArray = JSON.parse(JSON.stringify(data.missionsRank));
      for (let i = 0; i < pieChartTempArray.length; i++) {
        if (
          pieChartTempArray[i].title == 'سفید' &&
          !this.dashboardAdmissionPieRankChartOptions.colors.includes('#EBEBEB')
        ) {
          this.dashboardAdmissionPieRankChartOptions.colors.push('#EBEBEB');
        } else if (
          pieChartTempArray[i].title == 'سبز' &&
          !this.dashboardAdmissionPieRankChartOptions.colors.includes('#2EBA7F')
        ) {
          this.dashboardAdmissionPieRankChartOptions.colors.push('#2EBA7F');
        } else if (
          pieChartTempArray[i].title == 'زرد' &&
          !this.dashboardAdmissionPieRankChartOptions.colors.includes('#FFBD55')
        ) {
          this.dashboardAdmissionPieRankChartOptions.colors.push('#FFBD55');
        } else if (
          pieChartTempArray[i].title == 'قرمز' &&
          !this.dashboardAdmissionPieRankChartOptions.colors.includes('#DA6757')
        ) {
          this.dashboardAdmissionPieRankChartOptions.colors.push('#DA6757');
        }
        pieChartData.push({
          name: pieChartTempArray[i].title,
          y: pieChartTempArray[i].valueLong,
          tooltipText: 'تعداد',
        });
      }
      pieChartData = JSON.parse(JSON.stringify(pieChartData));
      this.dashboardAdmissionPieRankChartOptions.series[0].data = [];
      this.dashboardAdmissionPieRankChartOptions.series[0].data = pieChartData;
      //row 3
      let coluumnHospitalChartData = JSON.parse(JSON.stringify([]));
      let coluumnHospitalTempArray = JSON.parse(JSON.stringify([]));
      coluumnHospitalTempArray = JSON.parse(JSON.stringify(data.hospitals));
      for (let i = 0; i < coluumnHospitalTempArray.length; i++) {
        coluumnHospitalChartData.push({
          name: coluumnHospitalTempArray[i].title,
          y: coluumnHospitalTempArray[i].valueLong,
          text: coluumnHospitalTempArray[i].valueLong.toString(),
        });
      }
      coluumnHospitalChartData = JSON.parse(JSON.stringify(coluumnHospitalChartData));
      this.dashboardAdmissionColumnHospitalChartOptions.series[0].data = [];
      this.dashboardAdmissionColumnHospitalChartOptions.series[0].data = coluumnHospitalChartData;
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
  },
};
